import type { ComponentPropsWithoutRef } from 'react'

type Props = ComponentPropsWithoutRef<'svg'> & {
  filled?: boolean
  color: string
  width?: number
  height?: number
}

export function RatingStarIcon({
  filled = false,
  color,
  width = 48,
  height = 48,
  ...props
}: Props) {
  return (
    <svg
      role="presentation"
      viewBox="0 0 24 24"
      width={width}
      height={height}
      style={{ width: `${width}px`, height: `${height}px` }}
      {...props}
    >
      <path
        fill={filled ? color : 'transparent'}
        stroke={filled ? color : '#d1d5db'}
        strokeWidth={filled ? '2' : '1'}
        strokeLinejoin="round"
        strokeLinecap="round"
        d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"
      />
    </svg>
  )
}
